import { render, staticRenderFns } from "./ConfigurationSidepanelBasic.vue?vue&type=template&id=5194117e&"
import script from "./ConfigurationSidepanelBasic.vue?vue&type=script&lang=js&"
export * from "./ConfigurationSidepanelBasic.vue?vue&type=script&lang=js&"
import style0 from "./ConfigurationSidepanelBasic.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ConfigurationSidepanelBasic.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports